import {
	ThunkAction,
	configureStore,
	createSlice,
} from '@reduxjs/toolkit';
import { nextReduxCookieMiddleware, wrapMakeStore } from 'next-redux-cookie-wrapper';
import { HYDRATE, createWrapper } from 'next-redux-wrapper';
import { useDispatch } from 'react-redux';
import rootReducer from './reducers';

const makeStore = wrapMakeStore(() => configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware => getDefaultMiddleware().prepend(
		nextReduxCookieMiddleware({
			compress: true,
			subtrees: [
				'core.appointment',
				'user.user',
				'user.authentication',
				'user.appointments',
				'core.webConfig',
				'core.appPromptClose',
				'core.languageSelection',
				'core.firebaseRemoteConfigs',
				'core.deleteAccRequest',
				'core.doctorsList',
				'user.bookingPageURL',
			],
		}),
	),
}));

export const useAppDispatch = () => useDispatch();

export const wrapper = createWrapper(makeStore, { debug: false });

